import { Component, OnInit } from '@angular/core';
import { NibedonDtlsComponent } from 'src/app/admin/nibedon-in-progress/nibedon-dtls-dialog.component';
import { CategoryList } from 'src/app/core/interface/admin-table.interface';
import { CommentDialogComponent } from '../components/fly-out-dashboard-details/comment-dialog/comment-dialog.component';
import { nivedanStatus } from 'src/app/core/models/status.enum';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ToastrService } from 'ngx-toastr';
import { AuthService, DevoteeService } from 'src/app/core/services';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-public-nivedan',
  templateUrl: './public-nivedan.component.html',
  styleUrls: ['./public-nivedan.component.scss']
})
export class PublicNivedanComponent implements OnInit {
  categoryList: any[] = [
    {
      "_id": "69ee5b3a86f14ad1c844ba8b",
      "categoryCode": "MD",
      "description": "Medical",
      "isActive": true
    },
    {
      "_id": "69ee5b3a86f14ad1c844ba97",
      "categoryCode": "NK",
      "description": "Naam Karam",
      "isActive": true
    },
    {
      "_id": "69ee5b3a86f14ad1c844ba98",
      "categoryCode": "GG",
      "description": "General/Guidance/Counselling",
      "isActive": true
    }
  ];
  toolTip: string = 'Click to copy';
  mobileNibedonInProgress: any[] = [];

  isOtpValid: boolean = false;
  otp: string = ''
  id: any

  constructor(
    private bottomsheet: MatBottomSheet,
    private toaster: ToastrService,
    private devoteeService: DevoteeService,
    private authService: AuthService,
    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');

    this.requestOtp(this.id)

  }

  requestOtp(id: string | null) {
    const reqBody = {
      guestUserUUID: id
    }
    this.authService.requestOtp(reqBody).subscribe({
      next: (res) => {

      }
    })
  }

  getCategoryDescription(catCode: string): string {
    const categoryOption: CategoryList | undefined = this.categoryList.find(option => option.categoryCode === catCode);
    return categoryOption ? categoryOption.description : '';
  };


  openBottomSheetSlider(item: any) {
    const bottomsheetRef = this.bottomsheet.open(NibedonDtlsComponent, {
      data: item
    })
    bottomsheetRef.afterDismissed().subscribe({
      next: (res) => {
        if (res) {

          const bottomsheetRef = this.bottomsheet.open(CommentDialogComponent, {
            data: item
          })
          bottomsheetRef.afterDismissed().subscribe({
            next: (res) => {
              if (res) {
                // this.onRefreshTable()
              }
            }
          })
        }
      },
      error: (err) => {
        this.toaster.error(err)
      }
    })
  }

  onCopied(event: any) {
    event?.stopPropagation();
  }

  dynamicStatusColor(status: any) {
    switch (status) {
      case nivedanStatus.ASSIGNED:
        return 'solver-pending';
      case 'ADMIN PENDING':
        return 'admin-pending';
      case nivedanStatus.NEW:
        return 'open';
      case nivedanStatus.IN_REVIEW:
        return 'admin-pending'
      case nivedanStatus.RESOLVED:
        return 'resolved'
      case nivedanStatus.RESPONSE_PENDING:
        return 'response-pending'
      default:
        return 'status-default';
    }
  }

  formatStatus(status: string): string {

    return status
      .replace(/_/g, ' ')

  }

  submit() {
    if (this.otp) {
      const reqBody = {

        otp: this.otp,
        guestUserUUID: this.id

      }
      this.authService.verifyOtp(reqBody).subscribe({
        next: (res) => {
          this.isOtpValid = true
           res.assignedNivedans.forEach((elm: any) => {
            this.mobileNibedonInProgress.push(elm.nivedanId)
           })
          localStorage.setItem('guestToken', res.accessToken)
          console.log(this.mobileNibedonInProgress);

        }
      })
    } else {
      this.toaster.error('Enter your otp before proceeding')
    }
  }


}
